import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=fe93b3e0"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe93b3e0')) {
      api.createRecord('fe93b3e0', component.options)
    } else {
      api.reload('fe93b3e0', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=fe93b3e0", function () {
      api.rerender('fe93b3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Alerts.vue"
export default component.exports